import authenticate from '@/middleware/authenticate'
import store from '@/store'

export default [
  {
    path: '/shift-managements',
    name: 'shift-management',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/shift-management/index.vue')
  },
  {
    path: '/shift-managements/create',
    name: 'shift-management-create',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/shift-management/create.vue')
  },
  {
    path: '/shift-managements/:id',
    name: 'shift-management-edit',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/shift-management/edit.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('hr/shiftManagement/find', to.params.id)
      next()
    }
  }
]
